import styled from 'styled-components';
import base from '@sizeid/commons/utils/base';

export default styled.img`
  width: 50px;
  display: block;
  margin: ${base(1.5)} auto;
`;
